import React from 'react';
import {withTranslation} from 'react-i18next';
import {Field, Form as FinalForm} from 'react-final-form';
import {Button, Col, Form, Input, Row, Label, FormGroup, InputGroup} from 'reactstrap';
import {composeValidators, mustBeInteger, mustBeNumber, mustBePositive, required} from '../helpers/Validators';
import {NotificationManager} from '../components/common/react-notifications';
import ModalManager from '../components/modal/ModalManager';
import LoaderButton from '../components/LoaderButton';
import FieldError from '../components/FieldError';
import Api from '../services/Api';
import {map} from 'lodash';

class SecurityVerificationForm extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loadings: {},
    };
  }

  onSubmit = async data => {
    const {onSubmit, accessData} = this.props;
    try {
      await onSubmit({
        accessTokens: JSON.stringify(map(data, (value, key) => ({
          email: accessData[key.split('email')[1]],
          token: value,
        }))),
      });
      ModalManager.close({
        isOpen: false
      });
    } catch (e) {
      console.log('error: ', e);
    }
  };

  resendEmail = async email => {
    const {t, action} = this.props;
    this.setState(({loadings}) => ({
      loadings: {
        ...loadings,
        [email]: true,
      },
    }));
    try {
      await Api.invoke('POST', '/admin-ui/send-email-access-token', {
        action,
        email,
      });
      NotificationManager.success(t('Verification email resent'), t('Message'));
    } catch (e) {
    } finally {
      this.setState(({loadings}) => ({
        loadings: {
          ...loadings,
          [email]: false,
        },
      }));
    }
  };

  render() {
    const {loadings} = this.state;
    const {t, accessData} = this.props;
    return (
      <FinalForm
        onSubmit={this.onSubmit}
        render={({handleSubmit, submitting, pristine, hasValidationErrors}) => {
          return (
            <Form>
              {map(accessData, (email, index) => (
                <Row key={index} className="mb-2">
                  <Col>
                    <Field name={`email${index}`} validate={composeValidators(required, mustBeNumber, mustBeInteger, mustBePositive)}>
                      {({input, meta}) => (
                        <FormGroup>
                          <Label for={email}>
                            {t('Please enter the token sent to email {{email}}.', {email})}
                            <LoaderButton
                              loading={!!loadings[email]}
                              style={{paddingLeft: 6, paddingRight: 6}}
                              color='info flat-btn-to-link py-1 ml-1'
                              onClick={async () => {await this.resendEmail(email);}}
                              disabled={submitting || !!loadings[email]}
                            >
                              {t('Resend')}
                            </LoaderButton>
                          </Label>
                          <InputGroup>
                            <Input
                              {...input}
                              id={email}
                              placeholder={t('Verification code')}
                              invalid={meta.modified && meta.invalid && !meta.pristine}
                            />
                          </InputGroup>
                          <FieldError name={`email${index}`}/>
                        </FormGroup>
                      )}
                    </Field>
                  </Col>
                </Row>
              ))}
              <Row className="mt-4">
                <Col>
                  <LoaderButton
                    color="success"
                    loading={submitting}
                    disabled={pristine || hasValidationErrors || submitting}
                    className="text-center"
                    style={{minWidth: '100px'}}
                    onClick={handleSubmit}>
                    {t('Final Confirmation and Submit')}
                  </LoaderButton>
                  <Button
                    color="grey"
                    onClick={() =>{
                      ModalManager.close({
                        isOpen: false
                      });
                    }}
                    className="text-center mx-2"
                    style={{minWidth: '100px'}}>
                    {t('Close')}
                  </Button>
                </Col>
              </Row>
            </Form>
          );
        }}
      />
    );
  }
}

export default withTranslation()(SecurityVerificationForm);
